import {
    FETCH_ALL_CHIP_GOLF_STATS,
    FETCH_ALL_CHIP_GOLF_STATS_SUCCESS,
    FETCH_FILTERED_CHIP_GOLF_STATS,
    FETCH_FILTERED_CHIP_GOLF_STATS_SUCCESS,
    SET_CHIP_GOLF_STATS_FILTER
} from '../../actions/ActionTypes.js';

// filtered - filtered for clubs
// gdpr safe - intended for unity, remove sensitive data for GDPR purposes

const INITIAL_STATE = {
    isFetching: false,
    payload: {},
    filteredPayload: {},
    gdprSafePayload: {},
    gdprSafeFilteredPayload: {},
    allClubIds: [],
    clubIdsSelected: [],
    areClubIdsSaved: true
};

const fetchAllChipGolfStatsSuccess = (state, action) => {
    let clubIds = new Set();
    if (action.chipGolfStats.shotOrientationDetail) {
        action.chipGolfStats.shotOrientationDetail.forEach((shotOrientation) => {
            if (clubIds.has(shotOrientation.clubId)) {
                return false;
            }
            clubIds.add(shotOrientation.clubId);
            return true;
        });
    }

    return {
        isFetching: false,
        payload: action.chipGolfStats,
        gdprSafePayload: filterForGDPR(action.chipGolfStats),
        filteredPayload: action.chipGolfStats,
        gdprSafeFilteredPayload: filterForGDPR(action.chipGolfStats),
        allClubIds: [...clubIds],
        clubIdsSelected: [],
        areClubIdsSaved: true
    };
};

const fetchFilteredChipGolfStatsSuccess = (state, action) => {
    return {
        ...state,
        filteredPayload: action.chipGolfStats,
        gdprSafeFilteredPayload: filterForGDPR(action.chipGolfStats)
    };
};

const setChipGolfStatsFilter = (state, action) => {
    //Only saving to the clubIdsSelected when the user confirms the modal selection for which club they will filter by
    if (action.areClubIdsSaved) {
        return {
            ...state,
            clubIdsSelected: action.clubIdsSelected || []
        };
    } else {
        return {
            ...state,
            unsavedIdsSelected: action.clubIdsSelected || []
        };
    }
};

const handlers = {
    [FETCH_ALL_CHIP_GOLF_STATS_SUCCESS]: fetchAllChipGolfStatsSuccess,
    [SET_CHIP_GOLF_STATS_FILTER]: setChipGolfStatsFilter,
    [FETCH_FILTERED_CHIP_GOLF_STATS_SUCCESS]: fetchFilteredChipGolfStatsSuccess
};

export default function chipGolfStats(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// Actions
export function fetchAllChipGolfStats() {
    return {
        type: FETCH_ALL_CHIP_GOLF_STATS,
        isFetching: true
    };
}

export function fetchFilteredChipGolfStats(clubIds) {
    return {
        type: FETCH_FILTERED_CHIP_GOLF_STATS,
        isFetching: true,
        clubIds: clubIds
    };
}

export const getChipGolfStats = (state) => {
    return state.chipGolfStats;
};

const filterForGDPR = (chipGolfStats) => {
    // intended for use with Unity cntainer, GDPR compliant

    const dispersionDetails = chipGolfStats.shotOrientationDetail
        ? chipGolfStats.shotOrientationDetail.map((shot) => {
              return {
                  shotId: shot.shotId,
                  holeNumber: shot.holeNumber,
                  clubId: shot.clubId,
                  endingLieType: shot.endingLieType,
                  offsetAngle: shot.offsetAngle,
                  onePuttAfter: shot.onePuttAfter,
                  remainingDistance: shot.remainingDistance,
                  startingDistanceToHole: shot.startingDistanceToHole,
                  startingLieType: shot.startingLieType,
                  strokesGained: shot.strokesGained
              };
          })
        : [];

    return {
        usingClubtrack: chipGolfStats.usingClubtrack,
        percentHitGreen: chipGolfStats.percentHitGreen,
        percentHitGreen10: chipGolfStats.percentHitGreen10,
        percentHitGreen20: chipGolfStats.percentHitGreen20,
        percentHitGreen20Plus: chipGolfStats.percentHitGreen20Plus,
        percentLeftOfGreen: chipGolfStats.percentLeftOfGreen,
        percentLongOfGreen: chipGolfStats.percentLongOfGreen,
        percentMissedGreen: chipGolfStats.percentMissedGreen,
        percentRightOfGreen: chipGolfStats.percentRightOfGreen,
        percentShortOfGreen: chipGolfStats.percentShortOfGreen,
        shotOrientationDetail: dispersionDetails
    };
};
